// Libraries
import {
  Component,
  OnDestroy
} from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/interval';

/**
 * `BasePollingComponent` implements a component to make polling request.
 *
 * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
 * @export
 */
@Component({
  selector: 'wp-polling',
  template: ``
})
export class BasePollingComponent implements OnDestroy {
  // Public properties
  /**
   * Flag to maintain if request is running or not.
   */
  isRunning = false;

  // Protected properties
  /**
   * Default interval time
   */
  protected intervalTime = 1500000;

  // Private properties
  /**
   * Subscription.
   */
  private sub: Subscription;

  // Public methods
  /**
   * Start polling
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof BasePollingComponent
   */
  start() {
    // Start polling
    this.startPolling();
  }

  /**
   * End polling
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof BasePollingComponent
   */
  end() {
    // End polling
    this.endPolling();
  }

  /**
   * Reset polling
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof BasePollingComponent
   */
  reset() {
    // End polling
    this.endPolling();
    // Start polling
    this.startPolling();
  }

  /**
   * Implements on destroy method
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof BasePollingComponent
   */
  ngOnDestroy() {
    // End polling
    this.endPolling();
  }

  // Protected methods
  /**
   * Do polling to backend
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof BasePollingComponent
   */
  protected doPolling() {
    // Do nothing
  }

  // Private methods
  /**
   * Remove subscription
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof BasePollingComponent
   */
  private removeSubscription() {
    // Unsubscribe method
    if (this.sub) {
      this.sub.unsubscribe();
   }
  }

  /**
   * Start polling
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof BasePollingComponent
   */
  private startPolling() {
    // Check if is running
    if (!this.isRunning) {
      // Toggle running flag
      this.isRunning = true;
      // Do polling
      this.sub = Observable.interval(this.intervalTime).subscribe(() => {
        this.doPolling();
      });
    }
  }

  /**
   * End polling
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof BasePollingComponent
   */
  private endPolling() {
    // Toggle Running flag
    this.isRunning = false;
    // Remove subscription
    this.removeSubscription();
  }
}
